/** Animated loading spinner */
export default function LoadingIndicator() {
  return (
    <div className="text-left">
      <div className="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}
